<template>
    <customModal :containermd="true" @closeModal="closeModal">
        <template #title>
            {{ isEditMode ? 'Edit CTQ' : 'Create CTQ' }}
        </template>

        <template #body>
            <div class="modal-scroll-body">
                <div class="row ml-1">

                    <!-- ═══════════════ BASIC INFORMATION ═══════════════ -->
                    <div class="col-12 mb-2">
                        <h6 class="section-heading mb-0">Basic Information</h6>
                    </div>

                    <!-- CTQ ID -->
                    <div class="col-md-6 mb-2">
                        <label class="form-label mb-0">CTQ ID <sup><i class="fa fa-asterisk required"></i></sup></label>
                        <input type="text" class="form-control" v-model="form.ctqid"
                            :disabled="isEditMode"  @input="errors.ctqid = ''"/>
                             <span v-if="errors.ctqid" class="errorClass">
                            {{ errors.ctqid }}
                        </span>
                    </div>

                    <!-- CTQ Factor -->
                    <div class="col-md-6 mb-2">
                        <label class="form-label mb-0">
                            CTQ Factor <sup><i class="fa fa-asterisk required"></i></sup>
                        </label>
                        <input type="text" class="form-control" v-model="form.ctqFactor"
                            @input="errors.ctqFactor = ''" />
                        <span v-if="errors.ctqFactor" class="errorClass">
                            {{ errors.ctqFactor }}
                        </span>
                    </div>

                    <!-- Category -->
                    <div class="col-md-6 mb-2">
                        <label class="form-label mb-0">
                            Category <sup><i class="fa fa-asterisk required"></i></sup>
                        </label>
                        <input type="text" class="form-control" v-model="form.category"
                            @input="errors.category = ''" />
                        <span v-if="errors.category" class="errorClass">
                            {{ errors.category }}
                        </span>
                    </div>

                    <!-- Domain -->
                    <div class="col-md-6 mb-2">
                        <label class="form-label mb-0">Domain</label>
                        <input type="text" class="form-control" v-model="form.domain" />
                    </div>

                    <!-- Priority -->
                    <div class="col-md-6 mb-2">
                        <label class="form-label mb-0">Priority</label>
                        <input type="text" class="form-control" v-model="form.priority" />
                    </div>

                    <!-- Is Active -->
                    <div class="col-md-6 mb-2">
                        <label class="form-label mb-0"></label>
                        <div class="form-check mt-2">
                            <input type="checkbox" class="form-check-input" id="ctqActiveCheck"
                                v-model="form.isActive" />
                            <label class="form-check-label ms-2" for="ctqActiveCheck">
                                Active
                            </label>
                        </div>
                    </div>

                    <!-- Description -->
                    <div class="col-12 mb-2">
                        <label class="form-label mb-0">Description</label>
                        <textarea class="form-control" rows="2" v-model="form.ctqDescription"></textarea>
                    </div>

                    <!-- Measurement -->
                    <div class="col-12 mb-2">
                        <label class="form-label mb-0">Measurement</label>
                        <input type="text" class="form-control" v-model="form.measurement" />
                    </div>

                    <!-- Impact If Missing -->
                    <div class="col-12 mb-2">
                        <label class="form-label mb-0">Impact If Missing</label>
                        <textarea class="form-control" rows="2" v-model="form.impactIfMissing"></textarea>
                    </div>

                    <!-- ═══════════════ RISKS ═══════════════ -->
                    <!-- <div class="col-12 mb-2 d-flex justify-content-between align-items-center mt-2">
                        <h6 class="section-heading mb-0">Risks</h6>
                        <div class="position-relative cursor-pointer">
                            <img src="@/assets/img/create.png" width="17" @click="addRisk" alt="Add Risk" />
                            <div class="tool-tip">Add Risk</div>
                        </div>
                    </div> -->
                    <!-- <div class="col-12 mb-1 text-danger" v-if="riskError">{{ riskError }}</div>
                    <div class="col-12">
                        <table class="table table-bordered">
                            <thead class="table-light">
                                <tr>
                                    <th>Risk ID</th>
                                    <th>Risk Name</th>
                                    <th class="text-center">Remove</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(r, i) in form.risks" :key="i">
                                    <td>
                                        <input type="text" class="form-control" v-model="r.riskId"
                                            @input="riskError = ''" />
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" v-model="r.riskName"
                                            @input="riskError = ''" />
                                    </td>
                                    <td class="text-center">
                                        <i class="fa fa-trash edit-delete" @click="removeRisk(i)"></i>
                                    </td>
                                </tr>
                                <tr v-if="!form.risks.length">
                                    <td colspan="3" class="text-center text-muted">No risks added</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> -->

                    <!-- ═══════════════ LINKED KRIs ═══════════════ -->
                    <!-- <div class="col-12 mb-2 d-flex justify-content-between align-items-center mt-2">
                        <h6 class="section-heading mb-0">Linked KRIs</h6>
                        <div class="position-relative cursor-pointer">
                            <img src="@/assets/img/create.png" width="17" @click="addLinkedKRI"
                                alt="Add Linked KRI" />
                            <div class="tool-tip">Add Linked KRI</div>
                        </div>
                    </div> -->
                    <!-- <div class="col-12 mb-1 text-danger" v-if="kriError">{{ kriError }}</div>
                    <div class="col-12">
                        <table class="table table-bordered">
                            <thead class="table-light">
                                <tr>
                                    <th>Risk Indicator</th>
                                    <th class="text-center">Remove</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(k, i) in form.linkedKRIs" :key="i">
                                    <td>
                                        <select class="form-control" :value="k.categoryId"
                                            @change="onKriChange(i, $event)">
                                            <option value="">Select</option>
                                            <option v-for="option in kriOptions" :key="option.value"
                                                :value="option.value">
                                                {{ option.label }}
                                            </option>
                                        </select>
                                    </td>
                                    <td class="text-center">
                                        <i class="fa fa-trash edit-delete" @click="removeLinkedKRI(i)"></i>
                                    </td>
                                </tr>
                                <tr v-if="!form.linkedKRIs.length">
                                    <td colspan="2" class="text-center text-muted">No linked KRIs added</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> -->

                    <!-- ═══════════════ CRITICAL DATA POINTS ═══════════════ -->
                    <!-- <div class="col-12 mb-2 d-flex justify-content-between align-items-center mt-2">
                        <h6 class="section-heading mb-0">Critical Data Points</h6>
                    </div> -->
                    <!-- <div class="row align-items-end mb-3 pr-0">
                        <div class="col-md-5">
                            <label class="form-label">eCRF</label>
                            <select class="form-control cdp-control" v-model="selectedTemplateId"
                                @change="onTemplateChange">
                                <option value="">Select eCRF</option>
                                <option v-for="t in templates" :key="t.templateId" :value="t.templateId">
                                    {{ t.templateName }}
                                </option>
                            </select>
                            <span v-if="cdpError" class="text-danger">{{ cdpError }}</span>
                        </div>

                        <div class="col-md-5">
                            <label class="form-label">Fields</label>
                            <Multiselect
                                class="multiselect-theme"
                                v-model="selectedFields"
                                :options="templateFields"
                                mode="multiple"
                                :close-on-select="false"
                                :clear-on-select="false"
                                :preserve-search="true"
                                :disabled="!templateFields.length"
                                label="label"
                                value-prop="fieldName"
                                track-by="fieldName"
                                :object="true"
                                placeholder="Select fields"
                            />
                        </div>

                        <div class="col-md-2 d-flex justify-content-end align-items-end pr-0">
                            <div class="position-relative cursor-pointer cdp-add-btn">
                                <img src="@/assets/img/create.png" width="18" @click="addCriticalDataPoint"
                                    alt="Add Critical Data Point" />
                                <div class="tool-tip">Add</div>
                            </div>
                        </div>
                    </div> -->
                    <!-- <div class="col-12">
                        <table class="table table-bordered">
                            <thead class="table-light">
                                <tr>
                                    <th>eCRF</th>
                                    <th>Fields</th>
                                    <th class="text-center">Remove</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(c, i) in form.criticalDataPoints" :key="i">
                                    <td>{{ c.templateName }}</td>
                                    <td class="fields-cell">
                                        <span v-if="c.fieldnames === null" class="text-muted">
                                            All fields
                                        </span>
                                        <span v-else class="fields-text">
                                            {{ visibleFields(c).join(', ') }}
                                            <span
                                                v-if="c.fieldLabels.length > maxVisibleFields"
                                                class="more-less"
                                                @click="toggleFields(c)"
                                            >
                                                {{ c.showAll ? ' Show less' : ` +${c.fieldLabels.length - maxVisibleFields} more` }}
                                            </span>
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <i class="fa fa-trash edit-delete" @click="removeCriticalDataPoint(i)"></i>
                                    </td>
                                </tr>
                                <tr v-if="!form.criticalDataPoints.length">
                                    <td colspan="3" class="text-center text-muted">No Critical Data Points added</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> -->

                    <!-- ═══════════════ CRITICAL PROCESSES ═══════════════ -->
                    <!-- <div class="col-12 mb-2 d-flex justify-content-between align-items-center mt-2">
                        <h6 class="section-heading mb-0">Critical Processes</h6>
                        <div class="position-relative cursor-pointer">
                            <img src="@/assets/img/create.png" width="17" @click="addCriticalProcess"
                                alt="Add Critical Process" />
                            <div class="tool-tip">Add Critical Process</div>
                        </div>
                    </div> -->
                    <!-- <div class="col-12 mb-1 text-danger" v-if="processError">{{ processError }}</div>
                    <div class="col-12">
                        <table class="table table-bordered">
                            <thead class="table-light">
                                <tr>
                                    <th>Process ID</th>
                                    <th>Process Name</th>
                                    <th class="text-center">Remove</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(p, i) in form.criticalProcesses" :key="i">
                                    <td>
                                        <input type="text" class="form-control" v-model="p.processId"
                                            @input="processError = ''" />
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" v-model="p.processName"
                                            @input="processError = ''" />
                                    </td>
                                    <td class="text-center">
                                        <i class="fa fa-trash edit-delete" @click="removeCriticalProcess(i)"></i>
                                    </td>
                                </tr>
                                <tr v-if="!form.criticalProcesses.length">
                                    <td colspan="3" class="text-center text-muted">No critical processes added</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> -->

                    <!-- ═══════════════ QTLs ═══════════════ -->
                    <!-- <div class="col-12 mb-2 d-flex justify-content-between align-items-center mt-2">
                        <h6 class="section-heading mb-0">Quality Tolerance Limits (QTLs)</h6>
                        <div class="position-relative cursor-pointer">
                            <img src="@/assets/img/create.png" width="17" @click="addQtl" alt="Add QTL" />
                            <div class="tool-tip">Add QTL</div>
                        </div>
                    </div>
                    <div class="col-12 mb-1 text-danger" v-if="qtlError">{{ qtlError }}</div>
                    <div class="col-12">
                        <table class="table table-bordered">
                            <thead class="table-light">
                                <tr>
                                    <th>QTL ID</th>
                                    <th>QTL Name</th>
                                    <th class="text-center">Remove</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(q, i) in form.qtLs" :key="i">
                                    <td>
                                        <input type="text" class="form-control"
                                            :value="getCtQId(q.qtlid)" disabled />
                                    </td>
                                    <td>
                                        <select class="form-control" :value="q.qtlid"
                                            @change="onQtlChange(i, $event)">
                                            <option value="">Select</option>
                                            <option v-for="opt in qtlOptions" :key="opt.value"
                                                :value="opt.value">
                                                {{ opt.label }}
                                            </option>
                                        </select>
                                    </td>
                                    <td class="text-center">
                                        <i class="fa fa-trash edit-delete" @click="removeQtl(i)"></i>
                                    </td>
                                </tr>
                                <tr v-if="!form.qtLs.length">
                                    <td colspan="3" class="text-center text-muted">No QTLs added</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> -->

                    <!-- ═══════════════ REVIEW PLAN ═══════════════ -->
                    <!-- <div class="col-12 mb-2 mt-2">
                        <h6 class="section-heading mb-0">Review Plan</h6>
                    </div>

                    <div class="col-md-4 mb-3">
                        <label class="form-label">Review Frequency</label>
                        <input type="text" class="form-control" v-model="form.reviewPlan.reviewFrequency" />
                    </div>

                    <div class="col-md-4 mb-3">
                        <label class="form-label">Review Owner</label>
                        <input type="text" class="form-control" v-model="form.reviewPlan.reviewOwner" />
                    </div>

                    <div class="col-md-4 mb-3">
                        <label class="form-label">Review Method</label>
                        <input type="text" class="form-control" v-model="form.reviewPlan.reviewMethod" />
                    </div> -->

                    <!-- ═══════════════ SAVE BUTTON ═══════════════ -->

                    <div class="col-12 text-end mt-3">
                        <!-- <button class="cancel_btn py-1 px-4 mx-3" type="button" @click="clear">
                            {{ $t("navigations.clear") }}
                        </button> -->
                        <button class="save_btn px-4 py-1" @click="save">
                            {{ isEditMode ? "Update" : "Save" }}
                        </button>
                    </div>
                    

                </div>
            </div>
        </template>
    </customModal>
</template>

<script src="./CtqAddEditModal.js"></script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}

.edit-delete {
    color: #a13b7c;
    cursor: pointer;
}

.save_btn {
    background-color: #1ab394;
    border: none;
    color: #fff;
    border-radius: 4px;
}

.section-heading {
    font-weight: 600;
    color: #2f4050;
    border-bottom: 2px solid #e7eaec;
    padding-bottom: 6px;
}

.multiselect-theme {
    --ms-radius: 0;
    --ms-py: 0.4rem;
    --ms-option-font-size: 0.8rem;
    --ms-option-bg-selected-pointed: rgb(210, 210, 210);
    --ms-option-bg-selected: rgb(210, 210, 210);
    --ms-option-color-selected: #000;
    --ms-option-color-selected-pointed: #000;
}

.cdp-add-btn {
    margin-bottom: 6px;
}

.more-less {
    color: #1ab394;
    cursor: pointer;
    font-size: 0.85rem;
    white-space: nowrap;
    margin-left: 4px;
}

.fields-cell {
    max-width: 350px;
    white-space: normal;
    word-break: break-word;
    vertical-align: top;
}

.fields-text {
    display: inline-block;
    max-width: 100%;
    white-space: normal;
    word-break: break-word;
    line-height: 1.4;
}

.modal-scroll-body {
    max-height: 70vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 6px;
}
</style>